export default {
      id: "telapp-usage",
      viewBox: "0 0 28 26",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#telapp",
      toString: function () {
        return this.url;
      }
    }